export const getItemsInfoPanelSettingName = (userId) => {
  const locationId = HFN.apiConfig.locationid;

  if (userId === 0) {
      return false;
  }

  return "items-info-panel-" + userId + "-" + locationId;
};
